import PAAttendee from "./Attendee";

class Message{

    constructor(){
        const _temp = PAAttendee.generateRandomString(24);
        this.temp_id = _temp;
        this.id = _temp;
        this.created = 0;

        this.priority = false;      //this can be an alert or something important from the Event organizer

        this.attendee_id = "";

        this.link_with_id = 0;      //not used right now
        this.recipients = [];       //not used right now

        this.message = "";

        this.status = 0;
    }

}

export default Message;
